<template>
  <w-icon-wrapper
    :width='19.636'
    :height='24'
    icon-name='work-nav-warehouse-managment-icon'
    view-box='0 0 19.636 24'
  >
    <path
      id="_15_Lagerverwaltung_Icon"
      data-name="15_Lagerverwaltung_Icon"
      d="M120-896v-24h2.182v2.182h15.273V-920h2.182v24h-2.182v-2.182H122.182V-896Zm2.182-13.091h2.182v-4.364h6.545v4.364h6.545v-6.545H122.182Zm0,8.727h6.545v-4.364h6.545v4.364h2.182v-6.545H122.182Zm4.364-8.727h2.182v-2.182h-2.182Zm4.364,8.727h2.182v-2.182h-2.182Zm-4.364-8.727h0Zm4.364,8.727h0Z"
      transform="translate(-120 920)"
      fill="currentColor"
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconNavWarehouseManagement' };
</script>

